import { useEffect, useState } from "react";
import { InputAdornment, TextField, createTheme } from "@mui/material";

//import styles
import "./base-text-field.scss";

function BaseTextField({
    id,
    dir,
    label,
    type,
    name,
    defaultValue,
    value,
    setValue,
    onClick,
    onFocus,
    focused,
    inputRef,
    variant,
    size,
    register,
    error,
    radius,
    disabled,
    readOnly,
    multiline,
    rows,
    icon,
}) {
    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 900,
                lg: 1200,
                xl: 1536,
            },
        },
    });

    const [shrink, setShrink] = useState(false);
    useEffect(() => {
        if (!!value || !!focused) {
            setShrink(true);
        } else setShrink(false);
    }, [value, focused]);

    return (
        <TextField
            id={id}
            className="base-text-field"
            fullWidth
            dir={dir}
            label={label}
            type={type}
            name={name}
            defaultValue={defaultValue}
            value={value}
            onFocus={() => {
                setShrink(onFocus || true);
            }}
            focused={focused}
            onChange={register?.onChange ?? setValue}
            onBlur={e => {
                register?.onBlur(e);
                setShrink(!!e.target.value);
            }}
            onClick={onClick}
            ref={register?.ref}
            inputRef={inputRef}
            variant={variant}
            size={size}
            helperText={error}
            error={!!error}
            disabled={disabled}
            inputProps={{ readOnly: readOnly }}
            multiline={multiline}
            rows={rows}
            InputLabelProps={{ shrink }}
            InputProps={{
                startAdornment: <InputAdornment position="start">{icon}</InputAdornment>,
            }}
            sx={{
                height: multiline ? "auto" : "3rem",
                backgroundColor: disabled ? "var(--white-gray-color) !important" : "var(--light-color)",
                borderRadius: `${radius}`,
                "& input[type=number]::-webkit-inner-spin-button": {
                    WebkitAppearance: "none",
                    margin: 0,
                },
                [theme.breakpoints.down("md")]: {
                    height: multiline ? "auto" : "2.75rem",
                },
                "& label": {
                    color: "var(--teal-color-18)",
                    fontSize: "0.875rem",
                    marginLeft: icon && !shrink ? "1.5rem" : "0",
                    [theme.breakpoints.between("xs", "md")]: {
                        fontSize: "0.625rem",
                    },
                    "&.Mui-focused": {
                        color: "var(--primary-color)",
                        marginLeft: "0",
                    },
                },
                "& .MuiOutlinedInput-root": {
                    height: "100%",
                    "& fieldset": {
                        border: "0.5px solid var(--medium-gray-color)",
                        borderRadius: `${radius}`,
                    },
                    "&:hover fieldset": {
                        border: "0.5px solid var(--medium-gray-color)",
                    },
                    "&.Mui-focused fieldset": {
                        border: "0.5px solid var(--medium-gray-color)",
                    },
                },
                "& .MuiInputAdornment-root": {
                    zIndex: 9,
                },
                "& .MuiOutlinedInput-input": {
                    paddingRight: "7px !important",
                    paddingLeft: "7px !important",
                    display: "flex",
                    alignItems: "center",
                },
                "& input": {
                    fontSize: "0.875rem",
                    borderRadius: `${radius}`,
                    "&:-webkit-autofill": {
                        padding: "12.5px 14px",
                        borderRadius: `${radius}`,
                    },
                    [theme.breakpoints.down("md")]: {
                        fontSize: "0.75rem",
                    },
                },
                "& textarea": {
                    fontSize: "0.875rem",
                    [theme.breakpoints.down("md")]: {
                        fontSize: "0.75rem",
                    },
                },
                "& .MuiFormHelperText-contained": {
                    [theme.breakpoints.down("md")]: {
                        fontSize: "0.625rem",
                    },
                },
            }}
        />
    );
}

export default BaseTextField;
